export const WS_DISCONNECTION_SNACKBAR_TEXT = 'Ошибка подключения';
export const WS_DISCONNECTION_SNACKBAR_BUTTON_TEXT = 'Обновить';
